<template>
  <generic-view
    :title="$t('phone numbers')"
    icon="mobile"
    v-bind:searchable="true"
    v-bind:configurable="false"
    v-bind:show_plus="true"
    v-on:add="add"
    v-on:filter="filter"
  >
    <div class="ui relaxed divided selection list">
      <div class="item" v-for="(item, index) in phone_numbers" v-bind:key="index">
        <div
          class="ui tiny right floated basic icon labeled button"
          v-on:click="send_sms(item, index)"
        >
          <i class="blue envelope icon"></i>
          {{ $t("send sms") }}
        </div>
        <div class="ui tiny right floated basic icon labeled button" v-on:click="edit(item, index)">
          <i class="orange edit icon"></i>
          {{ $t("edit") }}
        </div>
        <div
          class="ui tiny right floated basic icon labeled button"
          v-on:click="remove(item, index)"
        >
          <i class="red trash icon"></i>
          {{ $t("delete") }}
        </div>
        <i class="large mobile middle aligned icon"></i>
        <div class="content">
          <a class="header">
            {{ item.setup.number }}
            <small>| {{ item.setup.type }}</small>
          </a>
          <div class="description">{{ item.setup.description }}</div>
          <div class="extra">{{ item.create_date | fromNow }}</div>
        </div>
      </div>
    </div>
    <template v-for="(mdl, index) in phone_modals">
      <component
        :is="mdl"
        :key="index"
        :phone="selected_phone"
        :customer="$props.customer"
        v-on:succedded="succedded"
        v-on:destroy="destroy"
      ></component>
    </template>
  </generic-view>
</template>

<script>
import { local_api, error_toast, clone } from "@/utils";
import CustomerPhoneModal from "./CustomerPhoneModal";
import CustomerPhoneSMSModal from "./CustomerPhoneSMSModal";
import GenericView from "@/components/GenericContainer";
import moment from "moment";

export default {
  filters: {
    fromNow(value) {
      return moment(value).fromNow();
    }
  },
  props: {
    module: Object,
    customer: Object
  },
  components: {
    "generic-view": GenericView
  },
  data() {
    return {
      title: this.module.title,
      icon: this.module.icon,
      searchable: this.module.searchable,
      show_plus: this.module.show_plus,
      processing: false,
      phone_numbers: [],
      all_phone_numbers: [],
      phone_modals: [],
      selected_phone: {}
      // customer: {}
    };
  },
  methods: {
    add() {
      this.phone_modals.push(CustomerPhoneModal);
    },
    remove(phone, index) {
      let vm = this;
      this.$alertify.confirm(
        this.$t("are you sure to remove phone?"),
        function() {
          local_api(vm, "post", "/customer_phone/do-remove", { u: phone.uuid })
            .then(() => {
              vm.phone_numbers.splice(index, 1);
            })
            .catch(err => {
              error_toast(err);
            });
        }
      );
    },
    destroy() {
      this.phone_modals = [];
      this.selected_phone = {};
    },
    succedded(phone) {
      let trgtIdx = this.phone_numbers.findIndex(n => n.uuid == phone.uuid);
      if (trgtIdx != -1) this.phone_numbers.splice(trgtIdx, 1, phone);
      else this.phone_numbers.push(phone);
    },
    edit(phone) {
      this.selected_phone = phone;
      this.phone_modals.push(CustomerPhoneModal);
    },
    // eslint-disable-next-line no-unused-vars
    send_sms(phone, index) {
      this.selected_phone = phone;
      this.phone_modals.push(CustomerPhoneSMSModal);
    },
    filter(query) {
      if (query == "") this.phone_numbers = this.all_phone_numbers;
      else
        this.phone_numbers = this.all_phone_numbers.filter(
          p =>
            p.setup &&
            (p.setup.number.toUpperCase().includes(query.toUpperCase()) ||
              p.setup.description.toUpperCase().includes(query.toUpperCase()) ||
              p.setup.type.toUpperCase().includes(query.toUpperCase()))
        );
    }
  },
  mounted() {
    let vm = this;
    this.processing = true;

    setTimeout(function() {
      local_api(vm, "post", "/customer_phone/do-get-initial-items", {
        uuid: vm.$props.customer.uuid
      })
        .then(items => {
          vm.phone_numbers = items;
          vm.all_phone_numbers = clone(items);
          vm.processing = false;
        })
        .catch(err => {
          error_toast(err);
          console.error(err);
        });
    }, 100);
  },
  watch: {}
};
</script>
